import { useState, useEffect } from "react";

export function usePersistedOpen(key, initial) {
  const storageKey = `rj_panel_${key}`;
  const [open, setOpen] = useState(() => {
    const v = localStorage.getItem(storageKey);
    return v === null ? initial : v === "1";
  });
  useEffect(() => { localStorage.setItem(storageKey, open ? "1" : "0"); }, [storageKey, open]);
  return [open, setOpen];
}
